<template>
  <div class="hp-manager-page-list">
    <a-button type="primary" v-if="permissionChecker('BomProduct.Edit') || permissionChecker('BomProduct.Create')" @click="handleOrg">修改销售范围</a-button>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="false" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a href="javascript:;" @click="deldata(rowKey.data)" :disabled="!(permissionChecker('BomProduct.Edit') || permissionChecker('BomProduct.Create'))">删除</a>
        </span>
      </template>
      <template slot="statusSwitch" slot-scope="rowKey">
        <span>
          <a-switch v-model="rowKey.data.isActive" :disabled="true" />
        </span>
      </template>
    </standard-table>
    <hp-manager-modal :title="paramsX.productName+'  销售范围 修改'" v-model="addVisible" width="1200px">
      <hp-manager-page-productOrg-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :paramsX="params"></hp-manager-page-productOrg-add>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";
import hpManagerPageProductOrgAdd from "./AddRelationOrg";
export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageProductOrgAdd
  },
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      filter: [],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 80,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "销售组织",
          dataIndex: "organizationName",
          sorter: true
          //width: 200
        },
        {
          title: "修改时间",
          width: 150,
          dataIndex: "creationTime",
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        },
        {
          title: "状态",
          width: 100,
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ],
      datas: [],
      filterdata: Object.assign(JSON.parse(JSON.stringify(config.pageFilter))),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px",
      productId: 0,
      title: ""
    };
  },
  async mounted() {
    this.productId = this.paramsX.id;
    if (
      !permissionChecker("BomProduct.Edit") &&
      !permissionChecker("BomProduct.Create")
    ) {
      this.columns = this.columns.filter(a => a.dataIndex != "action");
    }
    this.getDatas();
  },
  methods: {
    handleOrg() {
      this.params = this.paramsX;
      this.addVisible = true;
    },
    handleSubmit(p) {
      this.getDatas();
    },

    refreshCurrent() {
      this.addVisible = false;
      this.getDatas();
    },
    tableChange(table) {
      this.getDatas();
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DeleteBomProductOrg({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },

    async getDatas() {
      this.loading = true;
      let data = await api.GetBomProductOrgList({ productId: this.productId });
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Goods/BomProduct/RelationOrgList.vue